import React, { useEffect, useRef, useState } from 'react';

import { isArray } from 'lodash';

import HighchartsReact from 'highcharts-react-official';

// components
import MapChartNew from 'components/charts/mapChartNew/mapChartNew';
import DatasetCombo from 'components/charts/datasetCombo/datasetCombo';
import { ChartComboItem } from 'components/charts/chartCombo/chartCombo';
import IWPSlider from 'components/charts/slider/slider';
import ChartFilter from 'components/charts/chartFilter/chartFilter';
import ChartInfoButton from 'components/charts/chartInfoButton/chartInfoButton';
import ChartResetButton from 'components/charts/chartResetButton/chartResetButton';
import ChartTooltip from 'components/charts/chartTooltip/chartTooltip';

// utils
import chartsUtils, { DataCode, Dataset } from 'utils/charts.utils';

// styles
import './chart1.scss';
import ChartActionsMobile from 'components/charts/chartActionsMobile/chartActionsMobile';
import ChartLegend from 'components/charts/chartLegend/chartLegend';

const Chart1 = () => {
  const [chartRef, setChartRef] = useState<any>();
  const [dataset, setDataset] = useState<Dataset>(chartsUtils.getDatasets()[1]);
  const [dataCode, setDataCode] = useState<DataCode>(DataCode.steueranteile);
  const [year, setYear] = useState<number>(chartsUtils.getMaxYear(dataset, dataCode));
  const [noDataYear, setNoDataYear] = useState<number>(0);

  const getDatasetChartComboItem = () => {
    return {
      text: dataset.name,
      value: dataset.code,
    } as ChartComboItem;
  };

  const getNoDataNextYear = (year: number) => {
    return chartsUtils.getAvailableYear(dataset, dataCode, year);
  };

  const handleDatasetChange = (value: ChartComboItem) => {
    setDataset({
      code: value.value,
      name: value.text,
    });
  };

  const handleChangeYear = (value: number | number[]) => {
    setNoDataYear(0);
    if (!isArray(value)) {
      setYear(value);
    } else {
      setYear(value[0]);
    }
  };

  const handleReset = () => {
    setNoDataYear(0);
    setDataCode(DataCode.steueranteile);
    setYear(chartsUtils.getMaxYear(dataset, DataCode.steueranteile));
  };

  const handleNoData = () => {
    setNoDataYear(year);
    setYear((year) => getNoDataNextYear(year));
  };

  const handleCallback = (chartRef: any) => {
    setChartRef(chartRef);
  };

  const handleExport = () => {
    if (chartRef) {
      chartRef.current.chart.exportChartLocal();
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setNoDataYear(0);
    }, 5000);
    return () => clearTimeout(timer);
  }, [noDataYear]);

  return (
    <div className="chart1">
      <div className="grid-row chartfilters-wrapper">
        <div className="grid-cell xs-5 md-auto">
          <DatasetCombo onChange={handleDatasetChange} value={getDatasetChartComboItem()}></DatasetCombo>
        </div>
        <div className="grid-cell d-none d-md-block md-auto" style={{ minWidth: '173px' }}></div>
        <div className="grid-cell xs-12 md-grow chartfilters-slider-container">
          <IWPSlider
            range={false}
            min={chartsUtils.getMinYear(dataset, dataCode)}
            max={chartsUtils.getMaxYear(dataset, dataCode)}
            onChange={handleChangeYear}
            value={year}
          />
          <ChartTooltip
            show={noDataYear > 0}
            text={`Sie haben ein Jahr ausgewählt, für das keine Daten verfügbar sind. Früher wurde die Steuergrundlage nicht jährlich bemessen. Ihnen wird das nächsthöhere verfügbare Jahr angezeigt.`}
          />
        </div>
        <div className="grid-cell md-auto chartfilters-actions">
          <div className="grid-row">
            <div className="grid-cell">
              <ChartResetButton onClick={handleReset} />
            </div>
            <div className="grid-cell">
              <ChartInfoButton text="Geben Sie rechts an, für welches Jahr Sie sich interessieren. Wenn Sie die generierte Grafik herunterladen möchten, klicken Sie bitte auf das Pfeilsymbol links." />
            </div>
          </div>
        </div>
      </div>
      <div className="chart1-wrapper">
        <MapChartNew
          dataCode={dataCode}
          dataset={dataset}
          title="Top {DATASET} Steueranteil {YEAR}"
          year={year}
          options={{
            legend: {
              title: {
                text: '<span class="mapchart-legendtitle">Steueranteil (in Prozent)</span>',
              },
              width: 250,
              symbolWidth: 250,
            },
            tooltip: {
              headerLabel1: 'JAHR',
              headerLabel2: 'ANTEIL (in % )',
            },
          }}
          onNoData={handleNoData}
          onCallback={handleCallback}
        />
      </div>
      <ChartActionsMobile onExport={handleExport} onReset={handleReset}></ChartActionsMobile>
      <ChartLegend onExport={handleExport} />
    </div>
  );
};

export default Chart1;
